<!--
  Each <ng-content> appears exactly once, and the chrome around it is what
  varies. Repeating a slot inside both branches of an @if looks equivalent but
  is not: a projected node is assigned to one slot index at compile time, so
  the second copy would always render empty.
-->
@if (variant() === 'card') {
  <div class="bz-toast__header">
    <bz-icon class="bz-toast__icon" [icon]="toneIcon()" />
    <span class="bz-toast__title">{{ title() }}</span>
    @if (dismissible()) {
      <ng-container [ngTemplateOutlet]="close" />
    }
  </div>
}

<div class="bz-toast__body">
  @if (variant() === 'push') {
    <bz-icon class="bz-toast__icon" [icon]="toneIcon()" />
  }

  <span class="bz-toast__message"><ng-content /></span>

  @if (variant() === 'push' && dismissible()) {
    <ng-container [ngTemplateOutlet]="close" />
  }
</div>

@if (variant() === 'card') {
  <div class="bz-toast__actions"><ng-content select="[bzToastActions]" /></div>
}

<ng-template #close>
  <button
    type="button"
    class="bz-toast__close"
    [attr.aria-label]="dismissLabel()"
    (click)="dismissed.emit()"
  >
    <bz-icon [icon]="closeIcon" size="xl" />
  </button>
</ng-template>
